export type AnchorTarget = '_blank' | '_parent' | '_self' | '_top'

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target
export const anchorTargets = ['_blank', '_parent', '_self', '_top'] as const
